import { pathSubscription, useReframe } from 'nike-re-framejs';

export enum PushConnectionStatus {
    Connected = 'Connected',
    Disconnected = 'Disconnected'
}

export function usePushConnectionStatus() {
    const derefSub = useReframe();
    const pushConnectionStatus: PushConnectionStatus = derefSub(pushConnectionStatus$);

    return {
        pushConnectionStatus,
        isPushConnected: pushConnectionStatus === PushConnectionStatus.Connected,
        isPushDisconnected: pushConnectionStatus === PushConnectionStatus.Disconnected
    };
}

export const onPushConnectionStatusChanged = (status: PushConnectionStatus) => db =>
    db.setIn(['push', 'connectionStatus'], status);

const pushConnectionStatus$ = pathSubscription(['push', 'connectionStatus']);
